import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" aria-labelledby="faq-heading" className="bg-navy-950" data-id="element-33" data-mp="1bmllj4fjvriw">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-34" data-mp="1gketo30eyvlt">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr]" data-id="element-35" data-mp="28arvm6v8rc4k">
          <div data-id="element-36" data-mp="28a000w1n9eea">
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-celeste-400" data-id="element-37" data-mp="28cw1gucpal7h">
              সরল উত্তর
            </p>
            <h2 id="faq-heading" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-38" data-mp="1zhy5fee9asbx">
              সাধারণ জিজ্ঞাসা
            </h2>
          </div>

          <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-39" data-mp="2rz0n0eoyne30">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <li key={faq.question} data-id="element-40" data-mp="10tp3mpr216yi" data-mpi={index}>
                  <h3 data-id="element-41" data-mp="10uqg8ynpy1ic">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-200 ease-smooth hover:text-celeste-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-celeste-400" data-id="element-42" data-mp="10vjo62yeyx22">
                      <span className="font-display text-lg font-bold tracking-tight text-inherit" data-id="element-43" data-mp="1jj52z9r06tdc">
                        {faq.question}
                      </span>
                      <PlusIcon className={`mt-1 h-5 w-5 shrink-0 text-celeste-400 transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-44" data-mp="1skv3d52v52n9" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-45" data-mp="3udazk362fezr">
                    {isOpen ? <motion.div id={`faq-panel-${index}`} key="panel" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-46" data-mp="1y938nr7khny7">
                        <p className="max-w-2xl pb-6 pr-8 text-[15px] leading-relaxed text-white/70" data-id="element-47" data-mp="2h5ux0f1yut94">
                          {faq.answer}
                        </p>
                      </motion.div> : null}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}